var map = {
	"./Work.svg": "23c1",
	"./XtDesign.svg": "5b1f",
	"./admin.svg": "9b4a",
	"./adminDownApp.svg": "0552",
	"./allNews.svg": "41e5",
	"./annotationNews.svg": "9a09",
	"./application.svg": "6aab",
	"./applicationSettings.svg": "70dd",
	"./approval.svg": "1915",
	"./authorization.svg": "8b89",
	"./board.svg": "3025",
	"./cehua.svg": "dbcd",
	"./centralFileBackup.svg": "ff7c",
	"./checkRegion.svg": "f4d0",
	"./daily.svg": "f5b1",
	"./doc.svg": "f769",
	"./downPlug.svg": "fd0a",
	"./examineApprove.svg": "20e6",
	"./flowNews.svg": "f353",
	"./folderTemplate.svg": "d0f2",
	"./formSettings.svg": "1945",
	"./holidaySettings.svg": "b82a",
	"./home.svg": "607e",
	"./largeScreenDesign.svg": "ee0a",
	"./lightMonitoring.svg": "c393",
	"./logmanagement.svg": "b938",
	"./logoSetting.svg": "e508",
	"./maintenance.svg": "7468",
	"./manageVersion.svg": "5204",
	"./manualHelp.svg": "3fce",
	"./message.svg": "9740",
	"./meta-data.svg": "55b7",
	"./myAgency.svg": "5ee4",
	"./myCopysend.svg": "0e8b",
	"./myEstablish.svg": "352f",
	"./myFinished.svg": "e724",
	"./myNotice.svg": "0567",
	"./notice.svg": "c1e2",
	"./orgFrameworkConfig.svg": "6029",
	"./otherNews.svg": "6b8a",
	"./permission.svg": "e051",
	"./personInfo.svg": "d176",
	"./personPlan.svg": "c895",
	"./prjBoard.svg": "2b4c",
	"./prjpro.svg": "6dc0",
	"./project.svg": "f0b3",
	"./projectNews.svg": "63fb",
	"./recentdoc.svg": "95e7",
	"./resourceAssign.svg": "75f6",
	"./richTextStore.svg": "0137",
	"./settings.svg": "527d",
	"./sheetSet.svg": "6e67",
	"./sysAnnouncementInfo.svg": "4d30",
	"./sysSetting.svg": "c3364",
	"./tagManagement.svg": "5b65",
	"./task.svg": "091b",
	"./taskNews.svg": "683b",
	"./taskPackage.svg": "40cd",
	"./userCount.svg": "3f7c",
	"./webPdfSign.svg": "26ff",
	"./weekly.svg": "27f9",
	"./workHours.svg": "5909",
	"./workProjectBoard.svg": "3ce1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1990";